module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clearfix"
  }, [_c('nav', {
    staticClass: "site-navbar navbar navbar-default navbar-mega navbar-inverse",
    attrs: {
      "role": "navigation"
    }
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('button', {
    staticClass: "navbar-toggler hamburger hamburger-close navbar-toggler-left",
    class: {
      'hided': !_vm.isShowSiteMenu
    },
    attrs: {
      "type": "button",
      "data-toggle": "menubar"
    },
    on: {
      "click": function($event) {
        _vm.showSiteMenu()
      }
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "hamburger-bar"
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-brand navbar-brand-center",
    attrs: {
      "to": ("/" + (_vm.$route.params.namespace) + "/")
    }
  }, [_c('img', {
    staticClass: "navbar-brand-logo navbar-brand-logo-normal",
    attrs: {
      "src": "/static/images/byteark-logo.png",
      "title": "ByteArk"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "navbar-container container-fluid"
  }, [_c('div', {
    staticClass: "collapse navbar-collapse navbar-collapse-toolbar",
    attrs: {
      "id": "site-navbar-collapse"
    }
  }, [_c('ul', {
    staticClass: "nav navbar-toolbar navbar-right navbar-toolbar-right"
  }, [_c('li', {
    staticClass: "nav-item dropdown"
  }, [_vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu dropdown-menu-right dropdown-menu-media switch-service",
    attrs: {
      "role": "menu"
    }
  }, [_c('li', {
    staticClass: "dropdown-menu-header",
    attrs: {
      "role": "presentation"
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t("menu.services")))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group",
    attrs: {
      "role": "presentation"
    }
  }, [_c('div', {
    attrs: {
      "data-role": "container"
    }
  }, [_c('div', {
    attrs: {
      "data-role": "content"
    }
  }, [_c('router-link', {
    staticClass: "non-link list-group-item bg-blue-grey-100",
    attrs: {
      "to": ("/" + (_vm.$route.params.namespace) + "/"),
      "role": "menuitem",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-left p-l-5 p-r-20"
  }, [_c('i', {
    staticClass: "icon md-account bg-red-600 white icon-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('h6', {
    staticClass: "media-heading"
  }, [_vm._v(_vm._s(_vm.$t("services.account.name")) + " "), _c('span', {
    staticClass: "tag tag-danger pull-xs-right"
  }, [_vm._v(_vm._s(_vm.$t("services.current.state")))])]), _vm._v(" "), _c('p', {
    staticClass: "media-meta"
  }, [_vm._v(_vm._s(_vm.$t("services.account.shortDescription")))])])])]), _vm._v(" "), _c('a', {
    staticClass: "non-link list-group-item",
    attrs: {
      "href": _vm.serviceS3URL,
      "role": "menuitem",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "media"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('h6', {
    staticClass: "media-heading"
  }, [_vm._v(_vm._s(_vm.$t("services.storage.name")))]), _vm._v(" "), _c('p', {
    staticClass: "media-meta"
  }, [_vm._v(_vm._s(_vm.$t("services.storage.shortDescription")))])])])]), _vm._v(" "), _c('a', {
    staticClass: "non-link list-group-item",
    attrs: {
      "href": _vm.serviceQoderURL,
      "role": "menuitem",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "media"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('h6', {
    staticClass: "media-heading"
  }, [_vm._v(_vm._s(_vm.$t("services.qoder.name")))]), _vm._v(" "), _c('p', {
    staticClass: "media-meta"
  }, [_vm._v(_vm._s(_vm.$t("services.qoder.shortDescription")))])])])]), _vm._v(" "), _c('a', {
    staticClass: "non-link list-group-item",
    attrs: {
      "href": _vm.serviceFleetURL,
      "role": "menuitem",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "media"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('h6', {
    staticClass: "media-heading"
  }, [_vm._v(_vm._s(_vm.$t("services.fleet.name")))]), _vm._v(" "), _c('p', {
    staticClass: "media-meta"
  }, [_vm._v(_vm._s(_vm.$t("services.fleet.shortDescription")))])])])])], 1)])]), _vm._v(" "), _c('li', {
    staticClass: "dropdown-menu-footer",
    attrs: {
      "role": "presentation"
    }
  }, [_c('router-link', {
    staticClass: "dropdown-item ",
    attrs: {
      "to": ("/" + (_vm.$route.params.namespace) + "/")
    }
  }, [_c('i', {
    staticClass: "icon md-pin",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', {
    staticClass: "text hidden-sm-down"
  }, [_vm._v("\n                  " + _vm._s(_vm.$t("services.current.use")) + " " + _vm._s(_vm.$t("services.account.name")) + " ")])])], 1)])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item nav-user clearfix dropdown"
  }, [_c('a', {
    staticClass: "nav-link navbar-avatar",
    attrs: {
      "data-toggle": "dropdown",
      "href": "#",
      "aria-expanded": "false",
      "data-animation": "scale-up",
      "role": "button"
    }
  }, [_c('span', {
    staticClass: "avatar avatar-online"
  }, [(_vm.currentUser) ? _c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": _vm.currentUser.display_image.sizes.default.url,
      "alt": "image-profile"
    }
  }) : _c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "/static/images/user.png",
      "alt": "image-profile"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "username"
  }, [_vm._v(_vm._s(this.currentUser.name))])]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu",
    attrs: {
      "role": "menu"
    }
  }, [_c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "to": ("/" + (_vm.$route.params.namespace) + "/self/profile"),
      "role": "menuitem"
    }
  }, [_c('i', {
    staticClass: "icon md-account",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('menu.profile')) + "\n              ")]), _vm._v(" "), _c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "to": ("/" + (_vm.$route.params.namespace) + "/self/password"),
      "role": "menuitem"
    }
  }, [_c('i', {
    staticClass: "icon md-key",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('menu.password')) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-divider"
  }), _vm._v(" "), _c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "to": ("/" + (_vm.$route.params.namespace) + "/logout"),
      "role": "menuitem"
    }
  }, [_c('i', {
    staticClass: "icon md-power",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('menu.logout')) + "\n              ")])], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "site-menubar site-menubar-light",
    class: {
      'show-site-menu': _vm.isShowSiteMenu
    }
  }, [_c('div', {
    staticClass: "site-menubar-body"
  }, [_c('div', [_c('ul', {
    staticClass: "site-menu",
    attrs: {
      "data-plugin": "menu"
    }
  }, [_c('li', {
    staticClass: "site-menu-category"
  }, [_vm._v(_vm._s(_vm.$t('menu.general')))]), _vm._v(" "), _c('li', {
    staticClass: "site-menu-item"
  }, [_c('router-link', {
    attrs: {
      "to": ("/" + (_vm.$route.params.namespace) + "/dashboard")
    }
  }, [_c('i', {
    staticClass: "site-menu-icon md-cloud-box",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "site-menu-title"
  }, [_vm._v(_vm._s(_vm.$t('menu.dashboard')))])])], 1), _vm._v(" "), (_vm.showBillingMenu) ? _c('li', {
    staticClass: "site-menu-item"
  }, [_c('router-link', {
    attrs: {
      "to": ("/" + (_vm.$route.params.namespace) + "/billing")
    }
  }, [_c('i', {
    staticClass: "site-menu-icon md-money-box",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "site-menu-title"
  }, [_vm._v(_vm._s(_vm.$t('menu.billing')))])])], 1) : _vm._e(), _vm._v(" "), (_vm.showTeamMenu) ? _c('li', {
    staticClass: "site-menu-item has-sub",
    class: {
      'open': _vm.isShowSubMenuTeam
    }
  }, [_c('a', {
    attrs: {
      "data-dropdown-toggle": "false"
    },
    on: {
      "click": function($event) {
        _vm.showSubMenuTeam()
      }
    }
  }, [_c('i', {
    staticClass: "site-menu-icon md-accounts-list"
  }), _vm._v(" "), _c('span', {
    staticClass: "site-menu-title"
  }, [_vm._v(_vm._s(_vm.$t('menu.team')))]), _vm._v(" "), _c('span', {
    staticClass: "site-menu-arrow"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "site-menu-sub",
    class: {
      'is-shown': _vm.isShowSubMenuTeam
    }
  }, [_c('li', {
    staticClass: "site-menu-item"
  }, [_c('router-link', {
    staticClass: "animsition-link",
    attrs: {
      "to": ("/" + (_vm.$route.params.namespace) + "/team/members")
    }
  }, [_c('span', {
    staticClass: "site-menu-title"
  }, [_vm._v(_vm._s(_vm.$t('member.labels.members')))])])], 1), _vm._v(" "), _c('li', {
    staticClass: "site-menu-item"
  }, [_c('router-link', {
    staticClass: "animsition-link",
    attrs: {
      "to": ("/" + (_vm.$route.params.namespace) + "/team/setting")
    }
  }, [_c('span', {
    staticClass: "site-menu-title"
  }, [_vm._v(_vm._s(_vm.$t('team.labels.setting')))])])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.showAdminMenu) ? _c('li', {
    staticClass: "site-menu-item has-sub",
    class: {
      'open': _vm.isShowSubMenuAdmin
    }
  }, [_c('a', {
    attrs: {
      "data-dropdown-toggle": "false"
    },
    on: {
      "click": function($event) {
        _vm.showSubMenuAdmin()
      }
    }
  }, [_c('i', {
    staticClass: "site-menu-icon md-developer-board",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "site-menu-title"
  }, [_vm._v(_vm._s(_vm.$t('menu.admin')))]), _vm._v(" "), _c('span', {
    staticClass: "site-menu-arrow"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "site-menu-sub",
    class: {
      'is-shown': _vm.isShowSubMenuAdmin
    }
  }, [_c('li', {
    staticClass: "site-menu-item"
  }, [_c('router-link', {
    staticClass: "animsition-link",
    attrs: {
      "to": ("/" + (_vm.$route.params.namespace) + "/admin/client-usage-history")
    }
  }, [_c('span', {
    staticClass: "site-menu-title"
  }, [_vm._v(_vm._s(_vm.$t('menu.clientUsageHistory')))])])], 1), _vm._v(" "), _c('li', {
    staticClass: "site-menu-item"
  }, [_c('router-link', {
    staticClass: "animsition-link",
    attrs: {
      "to": ("/" + (_vm.$route.params.namespace) + "/admin/teams")
    }
  }, [_c('span', {
    staticClass: "site-menu-title"
  }, [_vm._v(_vm._s(_vm.$t("action.manageClientTeam")))])])], 1), _vm._v(" "), _c('li', {
    staticClass: "site-menu-item"
  }, [_c('router-link', {
    staticClass: "animsition-link",
    attrs: {
      "to": ("/" + (_vm.$route.params.namespace) + "/admin/addon-cost")
    }
  }, [_c('span', {
    staticClass: "site-menu-title"
  }, [_vm._v(_vm._s(_vm.$t('menu.addons')))])])], 1), _vm._v(" "), _c('li', {
    staticClass: "site-menu-item"
  }, [_c('router-link', {
    staticClass: "animsition-link",
    attrs: {
      "to": ("/" + (_vm.$route.params.namespace) + "/admin/transactions")
    }
  }, [_c('span', {
    staticClass: "site-menu-title"
  }, [_vm._v(_vm._s(_vm.$t('menu.creditTransaction')))])])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.showResellerMenu) ? _c('li', {
    staticClass: "site-menu-item has-sub",
    class: {
      'open': _vm.isShowSubMenuReseller
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.showSubMenuAdmin()
      }
    }
  }, [_c('i', {
    staticClass: "site-menu-icon md-group-work",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "site-menu-title"
  }, [_vm._v(_vm._s(_vm.$t('menu.reseller')))])]), _vm._v(" "), _c('ul', {
    staticClass: "site-menu-sub",
    class: {
      'is-shown': _vm.isShowSubMenuReseller
    }
  }, [_c('li', {
    staticClass: "site-menu-item"
  }, [_c('router-link', {
    staticClass: "animsition-link",
    attrs: {
      "to": ("/" + (_vm.$route.params.namespace) + "/reseller/teams")
    }
  }, [_c('span', {
    staticClass: "site-menu-title"
  }, [_vm._v(_vm._s(_vm.$t('action.manageClientTeam')))])])], 1)])]) : _vm._e(), _vm._v(" "), (!_vm.showAdminMenu) ? _c('li', {
    staticClass: "site-menu-item"
  }, [_c('router-link', {
    attrs: {
      "to": ("/" + (_vm.$route.params.namespace) + "/support")
    }
  }, [_c('i', {
    staticClass: "site-menu-icon md-email",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "site-menu-title"
  }, [_vm._v(_vm._s(_vm.$t('menu.support')))])])], 1) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggler collapsed",
    attrs: {
      "type": "button",
      "data-target": "#site-navbar-collapse",
      "data-toggle": "collapse"
    }
  }, [_c('i', {
    staticClass: "icon md-more",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "nav-link nav-service",
    attrs: {
      "data-toggle": "dropdown",
      "href": "javascript:void(0)",
      "title": "Service"
    }
  }, [_c('i', {
    staticClass: "icon md-apps",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "media-left p-l-5 p-r-20"
  }, [_c('i', {
    staticClass: "icon md-storage bg-blue-600 white icon-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "media-left p-l-5 p-r-20"
  }, [_c('i', {
    staticClass: "icon md-videocam bg-blue-600 white icon-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "media-left p-l-5 p-r-20"
  }, [_c('i', {
    staticClass: "icon md-swap-vertical bg-blue-600 white icon-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-248496c3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavBar.vue
// module id = 517
// module chunks = 1